import { Option, UUID } from "@opendaw/lib-std";
// WebCLAP bundles live only in a user's OPFS, so a missing one can only come from a peer in the room
export class ChainedWclapProvider {
    #peer = Option.None;
    attachPeer(provider) { this.#peer = Option.wrap(provider); }
    detachPeer() { this.#peer = Option.None; }
    async fetch(uuid, progress) {
        return this.#peer.match({
            none: () => Promise.reject(new Error(`WebCLAP bundle ${UUID.toString(uuid)} is not available`)),
            some: peer => peer.fetch(uuid, progress)
        });
    }
}
